<div class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 px-4">
  <div class="w-full max-w-2xl bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-6">

    <!-- Logo no topo -->
    <div *ngIf="logo()" class="flex justify-center mb-6">
      <img [src]="logo()" alt="Logo" class="h-12">
    </div>

    <!-- Formulário de cadastro -->
    <ui-dynamic-form (valueChange)="userRegister($event)" [withBorder]="false" [useSteps]="true" [formName]="'Cadastro de Usuário'" [inList]="true" [fields]="currentFields"></ui-dynamic-form>

        <!-- Link para Login -->
        <div class="text-center mt-4">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Já possui uma conta?
            <a (click)="toLogin()" class="text-blue-500 hover:underline dark:text-blue-400 cursor-pointer">
              Faça o login
            </a>
          </p>
        </div>

  </div>
</div>
